export const STABLE_SWAP_API = 'https://configs.pancakeswap.com/api/data/cached/stableswaps'
